// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.CalculatedLabel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedLabel component
 */
import React from 'react';
import { observer } from 'mobx-react';
import EventsUtils from 'EventUtils';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';
import Validator from 'share/components/hoc/Izenda.Validator';
import FormGroup from 'share/components/controls/Izenda.FormGroup';
import Label from 'share/components/controls/Izenda.Label';
import Input from 'share/components/controls/Izenda.Input';
const ValidatableInput = Validator()(Input);

const CalculatedLabel = observer(
  ({ type, localization, store: { clonedModel: model }, requireLabel }) => {
    const notifyChange = EventsUtils.notifyChange;
    const nameValidation =
      (type.name === constants.TYPES.SUB_TOTAL.name ||
        type.name === constants.TYPES.GRAND_TOTAL.name) &&
      model.functionName === constants.FUNCTION_NAME.NONE
        ? {}
        : constants.COLUMN_NAME_CONSTRAINT(type.name);
    const labelValidationOption = {};
    if (requireLabel) {
      labelValidationOption.validations = constants.COLUMN_NAME_CONSTRAINT(
        type.name
      );
      labelValidationOption.field = 'columnName';
    }

    return (
      <FormGroup className="u_paddingRight">
        <Label className="col-md-3 text-left u_paddingLeft validation required">
          {type.name}
        </Label>
        <div className="col-md-9 u_noPaddingAll">
          <ValidatableInput
            value={model.name}
            className="form-control"
            field="name"
            onChange={notifyChange(
              model.changeFieldName.bind(model),
              EventsUtils.INPUT
            )}
            validations={nameValidation}
            {...labelValidationOption}
            type="text"
          />
        </div>
      </FormGroup>
    );
  }
);

CalculatedLabel.displayName = 'CalculatedLabel';
export default CalculatedLabel;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.CalculatedLabel.js